import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LoginFacade } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    template: ''
})
export class ViispPageComponent implements OnInit {
    private componentDestroyed$ = new Subject<void>();
    constructor(
        private route: ActivatedRoute,
        private loginFacade: LoginFacade,
        private router: Router,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.route.queryParams
            .pipe(map((params) => params.ticket))
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((ticket: string) => {
                this.loginFacade.loginWithViisp(ticket);
                this.router.navigate([this.translate.currentLang, 'login']);
            });
    }
}
